import { parsePhoneNumber } from 'libphonenumber-js'
import { AuthUser } from '../models'
import store from '../store'
import axios from 'axios'
import { email } from 'vee-validate/dist/rules.esm'
import JSSoup from 'jssoup'
import trim from 'lodash-es/trim'
import { i18n } from '../localization'

// const phoneUtil = libphonenumber.PhoneNumberUtil.getInstance()
const URLRegex = new RegExp(
  /(^\{{2,3})(\w+)(.\w+)?(\}{2,3}$)|(^(http|https):\/\/[^ "]+$)/g
)

const newURLRegex = new RegExp(
  /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,4}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/
)

export const phoneValidator = {
  getMessage(
    _field: string,
    _params: { [key: string]: any },
    data: { [key: string]: any }
  ) {
    return (data && data.message) || i18n.t('common.validations.invalidPhone')
  },
  validate(value: string) {
    if (!value) return true
    try {
      const phoneNumber = parsePhoneNumber(value)
      return phoneNumber.isValid()
    } catch (error) {
      return false
    }
  },
}
export const strongPwdValidator = {
  getMessage: _field =>
    'The password must be more than 8 characters including uppercase, lowercase, numbers and special characters.',
  validate: value => {
    var strongRegex = new RegExp(
      '^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*;:"\'{}()_/?|~.,<>`-])(?=.{8,})'
    )
    return strongRegex.test(value)
  },
}

export const uniqueEmailValidator = {
  getMessage: _field => 'A user with this email already exists in this agency.',
  validate: async (value, originalValue) => {
    if (originalValue.length > 0 && originalValue[0] === value) return true
    try {
      const auth: AuthUser = new AuthUser(await store.dispatch('auth/get'))
      const response = await axios.post('/exists', {
        email: value,
        companyId: auth.companyId,
      })
      return response.status === 200
    } catch (err) {
      return false
    }
  },
}

export const emailOrPhoneValidator = {
  getMessage(
    _field: string,
    _params: { [key: string]: any },
    data: { [key: string]: any }
  ) {
    return (data && data.message) || 'Invalid email address/phone number'
  },
  validate(value: string) {
    if (!value) return true
    try {
      const phoneNumber = parsePhoneNumber(value)
      return phoneNumber.isValid()
    } catch (error) {
      const emailRegex = new RegExp(
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      )
      return emailRegex.test(String(value).toLowerCase())
    }
  },
}

export const emailValidator = {
  getMessage: () => i18n.t('common.validations.invalidEmail'),
  validate: email.validate,
}

export const twilioPhoneValidator = {
  getMessage: () =>
    'You cannot use your inbound number here, it will create a call loop.',
  validate: (phone: string, phone_list: string[]) => {
    return !phone_list.includes(phone)
  },
}

export const twilioPhoneExcludeHostedValidator = {
  getMessage: () =>
    'You cannot use your inbound number here, it will create a call loop.',
  validate: (
    phone: string,
    numbers: { phone_numbers: string[]; hosted_numbers: { [key: string]: any } }
  ) => {
    if (numbers.phone_numbers.includes(phone)) {
      if (!numbers.hosted_numbers[phone]) {
        return false
      } else {
        return true
      }
    }
    return true
  },
}

export const handlebarsValidator = {
  getMessage: () =>
    'There are issues in your custom variables, please fix them before saving.',
  validate: (value: string, useJSSoup: boolean[] = [false]) => {
    const regex = /((^{{|[^{\n\r]{{)(?!{))(?!( ?(\w\.?)+ ?(}}(?!}))))|((^{{{|[^{\n\r]{{{)(?!{))(?!( ?(\w\.?)+ ?(}}}(?!}))))|{{4,}|^{(?= )/m

    if (useJSSoup[0]) {
      let soup = new JSSoup(value)
      let body = soup.find('body')
      const testString = body ? body.text : soup.text
      return !regex.test(testString)
    }

    return !regex.test(value)
  },
}

export const urlValidator = {
  getMessage: () => 'Invalid url.',
  validate: (value: string) => URLRegex.test(value),
}

export const newUrlValidator = {
  getMessage: () => 'Invalid url',
  validate: (value: string) => newURLRegex.test(value),
}

export const urlToEmptyValidator = {
  getMessage: () => 'Invalid url.',
  validate: (value: string) => {
    if (value == '') return true
    return URLRegex.test(value)
  },
}

export const notEmptyValidator = {
  getMessage: () => 'Field must not be empty.',
  validate: (value: string) => {
    return trim(value) !== ''
  },
}

export const requiredField = {
  getMessage(
    _field: string,
    _params: { [key: string]: any },
    data: { [key: string]: any }
  ) {
    return (data && data.message) || i18n.t('common.validations.requiredField', {fieldName: _field})
  },
  validate(value: string) {
    return trim(value) !== ''
  },
}